import api from "./api";

/**
 * Personel uçları (backend: /api/staff). Yanıtlar ApiResponse zarfında gelir
 * (res.data.data). Liste Spring Pageable döner: { content, totalElements, ... }.
 */
export const staffService = {
  list: (params = {}) => api.get("/staff", { params }),
  get: (id) => api.get(`/staff/${id}`),
  create: (payload) => api.post("/staff", payload),
  update: (id, payload) => api.put(`/staff/${id}`, payload),
  remove: (id) => api.delete(`/staff/${id}`), // soft delete (pasife al)
  hardRemove: (id) => api.delete(`/staff/${id}`, { params: { hard: true } }), // kalıcı sil
  setActive: (id, active) => api.patch(`/staff/${id}/status`, null, { params: { active } }),

  // Personel hareketleri (randevular/hizmetler/ciro özeti) — backend: /api/appointments/staff/{id}
  activity: (id, params = {}) => api.get(`/appointments/staff/${id}`, { params }),
};
